import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { SessionService } from './session.service';

export interface LangI {
  LanguageID: number;
  Name: string;
  IsLeft: boolean;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public LanguageList: LangI[] = [
    {
      LanguageID: 1,
      Name: 'en',
      IsLeft: true,
    },
    {
      LanguageID: 2,
      Name: 'ar',
      IsLeft: false,
    },
  ];

  toggleLanguageSubject = new BehaviorSubject(false);
  toggleLangugage$ = this.toggleLanguageSubject.asObservable();
  public CurrentLang = { LanguageID: 2, Name: 'ar', IsLeft: false };
  constructor(
    public translate: TranslateService,
    private session: SessionService
  ) { }

  initLanguage() {
    let storedLang = localStorage.getItem('lang');

    if (storedLang) {
      let currentLang = this.LanguageList.find((lang) => lang.Name.trim() == storedLang);

      if (currentLang)
        return this.setLanguage(currentLang);
    }
    else
    {
      return this.setLanguage(this.LanguageList[1]);
    }
  }

  public setLanguage(lang: LangI) {
    this.CurrentLang = lang;
    this.session.CurrentLang = lang;
    localStorage.setItem('lang', lang.Name);
    this.translate.use(lang.Name);
    this.setDirection(lang.IsLeft);
    this.toggleLanguageSubject.next(true);
  }

  public setDirection(isLeft: boolean) {
    if (!isLeft) {
      localStorage.setItem('dir', 'rtl');
      let root = document.querySelector('#cet-root');
      root?.setAttribute('dir', 'rtl');
      root?.setAttribute('lang', 'ar');
      return;
    }
    localStorage.setItem('dir', 'ltr');
    let root = document.getElementById('cet-root');
    root?.setAttribute('dir', 'ltr');
    root?.setAttribute('lang', 'en');
  }

  public toggle() {
    if (this.CurrentLang.Name === 'ar')
      return this.setLanguage(this.LanguageList[0]);
    return this.setLanguage(this.LanguageList[1]);
  }
  public SetArabic() {
    this.CurrentLang = this.LanguageList[1];
    return this.setLanguage(this.CurrentLang);
  }
  public SetEnglish() {
    this.CurrentLang = this.LanguageList[0];
    return this.setLanguage(this.CurrentLang);
  }
}
